<template>
  <router-link
    v-if="clickable !== false"
    :to="{
      name: 'ProductsItem',
      params: { lang: $i18n.locale, itemId: itemId },
    }"
    class="product-card-link"
  >
    <base-card
      class="mx-3 clickable-card"
      :title="title"
      :subtitle="desc"
      v-bind="$attrs"
      v-on="$listeners"
    >
      <base-img
        v-if="src"
        :aspect-ratio="4/3"
        :src="src"
        :alt="title"
        class="product-cover-img"
        contain
      />
    </base-card>
  </router-link>
  <div
    v-else
    class="product-card-wrapper not-clickable"
    @click.stop="handleNotClickable"
  >
    <base-card
      class="mx-3"
      :title="title"
      :subtitle="desc"
      v-bind="$attrs"
      v-on="$listeners"
    >
      <base-img
        v-if="src"
        :aspect-ratio="4/3"
        :src="src"
        :alt="title"
        class="product-cover-img"
        contain
      />
    </base-card>
  </div>
</template>

<script>
  export default {
    name: 'ProductCard',

    inheritAttrs: false,

    props: {
      src: String,
      title: String,
      desc: String,
      itemId: {
        type: [String, Number],
        default: 1,
      },
      clickable: {
        type: Boolean,
        default: true,
      },
    },

    methods: {
      handleNotClickable() {
        const message = this.$t('products.contact_business') || '请联系商务了解产品详情'
        const actionText = this.$t('contact.title')

        // 使用全局 snackbar 显示提示
        if (this.$root.$showSnackbar) {
          this.$root.$showSnackbar({
            message: message,
            color: 'info',
            timeout: 3000,
            actionText: actionText,
            actionCallback: () => {
              // 点击按钮后：先跳转到 Home，然后滚动到底部
              this.navigateToHomeAndScroll()
            },
          })
        }
      },

      navigateToHomeAndScroll() {
        // 检查当前路由
        const isOnHomePage = this.$route.name === 'Home'

        // 滚动到底部的函数
        const scrollToBottom = () => {
          // 等待 DOM 更新
          this.$nextTick(() => {
            // 延迟一下，确保页面内容已加载
            setTimeout(() => {
              window.scrollTo({
                top: document.documentElement.scrollHeight + 500,
                behavior: 'smooth',
              })
            }, 1000)
          })
        }

        // 如果不在 Home 页面，先跳转
        if (!isOnHomePage) {
          this.$router.push({ name: 'Home', params: { lang: this.$i18n.locale } }).then(() => {
            scrollToBottom()
          }).catch(() => {
            // 如果路由跳转失败，仍然尝试滚动
            scrollToBottom()
          })
        } else {
          // 如果已经在 Home 页面，直接滚动到底部
          scrollToBottom()
        }
      },
    },
  }
</script>

<style lang="sass" scoped>
  .product-cover-img
    border: thin solid rgba(0, 0, 0, .12)

  .product-card-link
    text-decoration: none
    display: block
    width: 100%
    color: inherit

    &:hover
      text-decoration: none
      color: inherit

  .product-card-wrapper
    width: 100%
    display: block

  .clickable-card
    cursor: pointer
    transition: all 0.3s ease

    &:hover
      transform: translateY(-2px)

    ::v-deep .v-card
      cursor: pointer
      transition: all 0.3s ease

      &:hover
        box-shadow: 0 8px 16px rgba(0, 0, 0, 0.15) !important

  .not-clickable
    cursor: pointer
    transition: all 0.3s ease

    &:hover
      transform: translateY(-2px)

    ::v-deep .v-card
      cursor: pointer
      transition: all 0.3s ease

      &:hover
        box-shadow: 0 8px 16px rgba(0, 0, 0, 0.15) !important

    // 确保所有子元素都能响应点击
    ::v-deep *
      pointer-events: auto
</style>
